// extracted by mini-css-extract-plugin
module.exports = {"subVerticalHeader":"SubVerticalHeader_subVerticalHeader__2thQz"};